<template>
  <div class="conference-detail row" v-if="bookDetail && conferenceDetail">
    <div class="col-xl-3 col-lg-3 col-md-12 col-sm-12 col-12">
      <div class="customer-info">
        <h5 class="mb-3 header">รายละเอียดผู้จอง</h5>
        <div class="mb-3">
          <p>ชื่อ</p>
          <h6>{{ bookDetail.firstName }} {{ bookDetail.lastName }}</h6>
        </div>
        <div class="mb-3">
          <p>เบอร์โทรศัพท์</p>
          <h6>{{ bookDetail.mobile }}</h6>
        </div>
        <div class="mb-3">
          <p>อีเมล</p>
          <h6>{{ bookDetail.email }}</h6>
        </div>
        <div class="mb-3">
          <p>บริษัท</p>
          <h6>{{ bookDetail.companyName }}</h6>
        </div>
        <div class="mb-4">
          <p>ที่อยู่</p>
          <h6>{{ bookDetail.address }}</h6>
        </div>
      </div>
    </div>
    <div class="col-xl-9 col-lg-9 col-md-12 col-sm-12 col-12 booking">
      <div class="pad">
        <h5 class="mb-3 header">รายละเอียดผู้จอง</h5>
        <div class="row">
          <div class="col-xl-3 col-lg-3 col-md-6 col-md-6 col-md-6 mb-3">
            <p>ห้องประชุม</p>
            <h6>{{ conferenceDetail.title }}</h6>
          </div>
          <div class="col-xl-3 col-lg-3 col-md-6 col-md-6 col-md-6 mb-3">
            <p>ขนาด</p>
            <h6>{{ conferenceDetail.usable }}</h6>
          </div>
          <div class="col-xl-3 col-lg-3 col-md-6 col-md-6 col-md-6 mb-3">
            <p>ที่ตั้ง</p>
            <h6>{{ conferenceDetail.address }}</h6>
          </div>
        </div>
      </div>
      <div class="book-info">
        <div class="mb-4 row pad">
          <div class="col-xl-3 col-lg-3 col-md-6 col-md-6 col-md-6 mb-2">
            <p>Booking No.</p>
            <h6>{{ bookDetail.id }}</h6>
          </div>
          <div class="col-xl-3 col-lg-3 col-md-6 col-md-6 col-md-6 mb-3">
            <p>สถานะ</p>
            <div :class="status.value">
              <el-select
                :value="bookDetail.status"
                clearable
                style="width: 100%"
                @input="handleChangeInput($event, 'status')"
              >
                <el-option
                  v-for="p in conferenceBookingStatus"
                  :value="p.value"
                  :label="p.label"
                  :key="p.value"
                  >{{ p.label }}</el-option
                >
              </el-select>
            </div>
          </div>
          <div class="col-xl-3 col-lg-3 col-md-6 col-md-6 col-md-6 mb-3">
            <p>วันที่จอง</p>
            <h6>{{ bookDate }}</h6>
          </div>
          <div class="col-xl-3 col-lg-3 col-md-6 col-md-6 col-md-6 right"></div>
          <div class="col-xl-3 col-lg-3 col-md-6 col-md-6 col-md-6 mb-3">
            <p>event name</p>
            <h6>{{ bookDetail.eventName }}</h6>
          </div>
          <div class="col-xl-3 col-lg-3 col-md-6 col-md-6 col-md-6 mb-3">
            <p>event detail</p>
            <h6>{{ bookDetail.eventDetail }}</h6>
          </div>
        </div>
        <div class="detail">
          <booking-manage-box-detail
            :conferenceDetail="conferenceDetail"
            :bookingDetail="bookingDetail"
            :isAdminRow="true"
          ></booking-manage-box-detail>
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
import PageWrapper from "@/lib/components/PageWrapper";
import { baanRueJaiClient } from "@/dependencies";
import { toCamelCaseObject } from "@/lib/util";
import { conferenceBookingStatus } from "@/lib/mapper";
import { convertDateTimeToTimeText } from "@/lib/dateTime";
import { Option, Select } from "element-ui";
import BookingManageBoxDetail from "../components/BookingManageBoxDetail.vue";

export default {
  components: {
    PageWrapper,
    "el-option": Option,
    "el-select": Select,
    BookingManageBoxDetail,
  },
  data() {
    return {
      title: "รายละเอียดการจอง",
      bookingDetail: null,
      conferenceDetail: null,
    };
  },
  created() {
    this.setup();
  },
  computed: {
    bookDetail() {
      return toCamelCaseObject(this.bookingDetail);
    },
    status() {
      if (!this.bookDetail || !this.bookDetail.status) {
        return { label: "unknown", value: "UNKNOWN" };
      }

      const bookingStatus = conferenceBookingStatus.find(
        (stat) => stat.value === this.bookDetail.status
      );

      return bookingStatus
        ? bookingStatus
        : { label: "unknown", value: "UNKNOWN" };
    },
    bookDate() {
      return this.bookDetail
        ? convertDateTimeToTimeText(this.bookDetail.createdAt)
        : null;
    },
    conferenceBookingStatus() {
      return conferenceBookingStatus;
    },
  },
  methods: {
    async setup() {
      await this.setupConferenceBookingDetail();
    },
    async setupConferenceBookingDetail() {
      this.bookingDetail = await this.fetchBooking();

      await this.setupConferenceProjectDetail();
    },
    async fetchBooking() {
      const { bookingId } = this.$route.params;

      try {
        return await baanRueJaiClient.others.conference.getConferenceBookingDetail(
          bookingId
        );
      } catch (err) {
        return [];
      }
    },
    async setupConferenceProjectDetail() {
      this.conferenceDetail = await this.fetchConference();
    },
    async fetchConference() {
      if (!this.bookingDetail || !this.bookingDetail.room_id) {
        return;
      }

      try {
        return await baanRueJaiClient.others.conference.getConferenceById(
          this.bookingDetail.room_id
        );
      } catch (err) {
        return [];
      }
    },
    handleChangeInput(value, key) {
      this.bookingDetail = {
        ...this.bookingDetail,
        [key]: value,
      };
    },
  },
};
</script>
  
  <style lang="scss" scoped>
@import "~@/lib/scss/variables";
@import "../../css/otherWebVariables.scss";

.conference-detail {
  padding-top: 30px;
  padding-bottom: 10px;
  background-color: white;
  text-align: left;
}

.customer-info {
  padding-left: 10%;
  padding-right: 10%;
}

.booking {
  border-left: solid 1px #d9d9d9;

  > .book-info {
    border-top: solid 2px #2d2a26;
  }
}

.right {
  text-align: right;
}

p {
  line-height: 1.6;
  font-size: 0.9rem;
  color: #777;
}

.badge {
  font-size: 0.9rem;
  padding: 4px 10px;
  border-radius: 4px;
  margin: auto;

  &.PENDING {
    background-color: $secondary-color;
  }

  &.CONFRIMED {
    background-color: $warning-color;
  }

  &.DONE {
    background-color: $success-color;
  }

  &.CANCELED {
    background-color: $danger-color;
  }

  &.UNKNOWN {
    background-color: $danger-color;
  }
}

.header {
  font-weight: bold;
}

.detail {
  padding-left: 15px;
  padding-right: 15px;
}

@media screen and (max-width: $ml-size) {
  .booking {
    border-left: 0;

    > .book-info {
      border-top: 0;
    }
  }

  .pad {
    padding-left: 10%;
    padding-right: 10%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/other-web/Conference/pages/ConferenceBookingEditDetail.vue